import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdviserMetadata } from '@syfo/types/adviser.types';

interface FetchAdvisersResponse {
  advisers: AdviserMetadata[];
  count: number;
}

/**
 * Fetch list of all advisers
 * Returns array of adviser metadata
 */
export const fetchAdvisersThunk = createAsyncThunk<AdviserMetadata[]>(
  'advisers/fetchAdvisers',
  async () => {
    console.log('[Advisers] Fetching advisers list...');
    
    const response = await fetch('/api/advisers');
    
    if (!response.ok) {
      throw new Error(`Failed to fetch advisers: ${response.status}`);
    }
    
    const data: FetchAdvisersResponse = await response.json();
    console.log(`[Advisers] Fetched ${data.count} advisers`);
    return data.advisers;
  }
);